import {
    AppBar,
    Box,
    Button,
    Container,
    Drawer,
    IconButton,
    Link,
    List,
    ListItemButton,
    ListItemText,
    Stack,
    Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import { colors, pagePadding } from './landingTheme';
import { navItems } from './landingData';

const LandingHeader = ({ isMobile, mobileOpen, toggleDrawer, onLogin }) => {
    const drawer = (
        <Box
            sx={{
                p: 2,
                bgcolor: 'rgba(15, 23, 42, 0.98)',
                borderBottom: '1px solid',
                borderColor: colors.line,
            }}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                <Typography sx={{ fontWeight: 800 }}>FiTra</Typography>
                <IconButton onClick={toggleDrawer} aria-label="Menü schließen">
                    <CloseIcon />
                </IconButton>
            </Stack>
            <List>
                {navItems.map((item) => (
                    <ListItemButton key={item.label} component="a" href={item.href} onClick={toggleDrawer}>
                        <ListItemText primary={item.label} primaryTypographyProps={{ fontWeight: 700 }} />
                    </ListItemButton>
                ))}
                <ListItemButton onClick={onLogin}>
                    <ListItemText primary="Anmelden" primaryTypographyProps={{ fontWeight: 700 }} />
                </ListItemButton>
            </List>
        </Box>
    );

    return (
        <>
            <Link
                href="#main-content"
                sx={{
                    position: 'absolute',
                    top: '-44px',
                    left: 12,
                    zIndex: 2000,
                    px: 2,
                    py: 1,
                    borderRadius: 1,
                    color: '#fff',
                    bgcolor: 'primary.main',
                    '&:focus': { top: 12 },
                }}
            >
                Zum Hauptinhalt springen
            </Link>

            <AppBar
                position="sticky"
                elevation={0}
                sx={{
                    bgcolor: 'rgba(15, 23, 42, 0.86)',
                    backdropFilter: 'blur(18px)',
                    borderBottom: '1px solid',
                    borderColor: colors.line,
                }}
            >
                <Container maxWidth={false} sx={pagePadding}>
                    <Stack direction="row" alignItems="center" spacing={2} sx={{ minHeight: 52 }}>
                        <Stack
                            component="a"
                            href="#"
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            sx={{ color: 'text.primary', textDecoration: 'none', mr: 'auto' }}
                        >
                            <FitnessCenterIcon sx={{ color: 'primary.main', fontSize: 23 }} />
                            <Typography sx={{ fontWeight: 700, fontSize: '0.98rem' }}>GymTracker</Typography>
                        </Stack>

                        <Stack direction="row" spacing={1.5} sx={{ display: { xs: 'none', md: 'flex' } }}>
                            {navItems.map((item) => (
                                <Button key={item.label} href={item.href} color="inherit" sx={{ minHeight: 32, px: 0.5 }}>
                                    {item.label}
                                </Button>
                            ))}
                        </Stack>

                        <Button
                            variant="contained"
                            onClick={onLogin}
                            sx={{ display: { xs: 'none', sm: 'inline-flex' }, minHeight: 34, px: 2.2 }}
                        >
                            Anmelden
                        </Button>
                        <IconButton
                            sx={{ display: { md: 'none' } }}
                            onClick={toggleDrawer}
                            color="inherit"
                            aria-label="Menü öffnen"
                            size="small"
                        >
                            <MenuIcon />
                        </IconButton>
                    </Stack>
                </Container>
            </AppBar>

            <Drawer
                anchor="top"
                open={mobileOpen && isMobile}
                onClose={toggleDrawer}
                sx={{ '& .MuiDrawer-paper': { bgcolor: 'transparent' } }}
            >
                {drawer}
            </Drawer>
        </>
    );
};

export default LandingHeader;
